export default __webpack_public_path__ + "static/7_21-2--cbb0e2ae9c5a82980418da9e75a040ea.png";